import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import auth from 'store/app/auth/action';
import visibility from 'store/app/ui/focus/action';
import authToken from 'store/selectors/authToken';
import keepSessionOpen from 'store/selectors/keepSessionOpen';

const mapStateToProps = state => {
  return {
    keepSessionOpen: keepSessionOpen(state),
    authToken: authToken(state),
    clientSecret: state.companies.clientSecret,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    visibility: bindActionCreators(visibility, dispatch),
    auth: bindActionCreators(auth, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
